import { useFetchLatestAppoinmentResults } from '@/api/hooks/useFetchLatestAppointmentResults'
import { ResultConditionsList } from '@/components/AppointmentResultsPage/ResultsConditionsList'
import { WallyHealthScore } from '@/components/AppointmentResultsPage/WallyHealthScore'
import { Header } from '@/ui/core/header'
import { VStack } from '@/ui/core/stack'
import { Text } from '@/ui/core/typography'

const ViewableAppointmentResults = () => {
	const { appointmentResults } = useFetchLatestAppoinmentResults()

	return (
		<VStack fullWidth>
			<VStack fullWidth className="mb-24">
				<VStack fullWidth className="flex-1 justify-start items-center">
					<VStack className="items-center justify-center" gap={6}>
						<WallyHealthScore score={appointmentResults?.healthScore} />
						<Header className="tracking-[.03em] pt-6" variant="h3">
							YOUR WALLY SCORE
						</Header>
						<Text className="max-w-[18em] text-center text-palette_6">
							Your Wally Score is based on your tooth and gum health, using insights from
							our X-rays and scans.
						</Text>
					</VStack>
				</VStack>
			</VStack>
			<VStack className="items-center">
				<ResultConditionsList conditions={appointmentResults?.conditions} />
			</VStack>
		</VStack>
	)
}

export { ViewableAppointmentResults }
